import { GuestCommentOnContentPackageMeta, GuestCommentOnContentPackagePayload } from 'types/store/GuestCommentOnContentPackage';
import { createAsyncReducer } from 'utils/Redux';

import { guestCommentOnContentPackageActions } from '../actions';

export default createAsyncReducer<GuestCommentOnContentPackageMeta, GuestCommentOnContentPackagePayload>(guestCommentOnContentPackageActions);
